<section class="md-page customer-item-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="flex align-items-center justify-content-between mb-3">
    <h2 class="m-0">Items</h2>
    <div class="flex gap-2">
      <p-button label="New Item" icon="pi pi-plus" (onClick)="createItem()"></p-button>
      <p-button label="Export" icon="pi pi-file-excel" styleClass="p-button-help" (click)="exportExcel()"></p-button>
    </div>
  </div>

  <div class="customer-item-filters mb-4 p-4 border-round-2xl">
    <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6 lg:col-4">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input pInputText formControlName="itemNumber" id="itemNumberFilter" class="w-full" />
              <label for="itemNumberFilter">Item Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-8 lg:col-8">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input pInputText formControlName="itemNameEnglish" id="itemNameEnglishFilter" class="w-full" />
              <label for="itemNameEnglishFilter">Item Name English</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="brand"
          [adapter]="brandPickerAdapter"
          inputId="brandFilter"
          label="Brand"
          placeholder="Any brand"
          filterPlaceholder="Filter brands"
          columnClass="col-12 md:col-6 lg:col-4"
          addonIconClass="pi pi-tags"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="subBrand"
          [adapter]="subBrandPickerAdapter"
          inputId="subBrandFilter"
          label="Sub Brand"
          placeholder="Any sub brand"
          filterPlaceholder="Filter sub brands"
          columnClass="col-12 md:col-6 lg:col-4"
          addonIconClass="pi pi-sitemap"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="business"
          [adapter]="businessPickerAdapter"
          inputId="businessFilter"
          label="Business"
          placeholder="Any business"
          filterPlaceholder="Filter businesses"
          columnClass="col-12 md:col-6 lg:col-4"
          addonIconClass="pi pi-building"
        ></app-entity-dropdown-picker>
      </div>

      <div class="flex justify-content-end gap-2 mt-4">
        <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button" (onClick)="onReset()"></p-button>
        <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
      </div>
    </form>
  </div>

  <p-table
    #dt
    [value]="items"
    [rows]="10"
    [paginator]="true"
    [totalRecords]="totalRecords"
    [loading]="isLoading"
    [lazy]="true"
    (onLazyLoad)="loadItems($event)"
    dataKey="itemId"
    styleClass="p-datatable-striped md-data-table customer-item-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 12rem">Actions</th>
        <th>Item No</th>
        <th>Item Name English</th>
        <th>Item Name Arabic</th>
        <th>Brand</th>
        <th>Sub Brand</th>
        <th>Business</th>
        <th>Item UOM</th>
        <th>Status</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <div class="flex gap-2">
            <p-button icon="pi pi-eye" styleClass="p-button-rounded p-button-info" (onClick)="viewItem(item.itemId!)"></p-button>
            <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-success" (onClick)="editItem(item.itemId!)"></p-button>
            <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger" (onClick)="deleteItem(item)"></p-button>
          </div>
        </td>
        <td>{{ item.erpItemNumber ?? '-' }}</td>
        <td>{{ item.erpItemNameE ?? '-' }}</td>
        <td>{{ item.erpItemNameA ?? '-' }}</td>
        <td>{{ item.brand?.brandName ?? '-' }}</td>
        <td>{{ item.subBrand?.subBrandName ?? '-' }}</td>
        <td>{{ item.business?.businessName ?? '-' }}</td>
        <td>{{ item.erpItemUom ?? '-' }}</td>
        <td>{{ item.erpItemStatus ?? '-' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9">No items found.</td>
      </tr>
    </ng-template>
  </p-table>
</section>
